import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../../../../shared/_services/employee.service';

@Component({
  selector: 'app-employee-guest-booking',
  templateUrl: './employee-guest-booking.component.html',
  styleUrls: ['./employee-guest-booking.component.scss']
})
export class EmployeeGuestBookingComponent implements OnInit {
  p: number = 0;
  size: number = 10;
  totalCount: number;
  employeeId: number | string;
  bookingList: any[] = [];
  tableHeader: any = [
    { 'key': 'Member', 'property': 'firstName', 'direction': null },
    { 'key': 'Locator', 'property': 'locator', 'direction': 'asc' },
    { 'key': 'Origin', 'property': 'origin', 'direction': null },
    { 'key': 'Agency', 'property': 'agency', 'direction': null },
    { 'key': 'Treatment', 'property': 'treatment', 'direction': null },
    { 'key': 'Hotel', 'property': 'hotelId', 'direction': null },
    { 'key': 'Check In', 'property': 'checkInDate', 'direction': null },
    { 'key': 'Check Out', 'property': 'checkOutDate', 'direction': null },
    { 'key': 'Status', 'property': 'status', 'direction': null },
  ];
  constructor(
    private employeeService: EmployeeService
  ) { }
  
  sortTable(property: any, ignoreFields?) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = null;
      }
    });
    if (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1) {
      this.pageChanged(1);
    }
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getEmployeeBookings(this.employeeId, page);
    this.p = $event;
  }

  getEmployeeBookings(empId?, page?) {
    let data = {
      page: page != null ? page : this.p,
      sorting: this.tableHeader
    }
    this.employeeService.getEmployeeBookings(empId, data).subscribe(res => {
      if(res.error == 0) {
        this.bookingList = res.responseObj.bookingTos;
        this.totalCount = res.responseObj.totalRecords;
      }
    })
  }

  ngOnInit() {
    this.employeeId = this.employeeService.employeeId;
    this.getEmployeeBookings(this.employeeId);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-guest-booking/employee-guest-booking.component.ts